import { FK } from "../../capabilities/featureKeys";

export const AI_AGENT_MENU_KEY = "ai_agent";

// Contextual links choose a known editor section; they never change configuration.
export function initialAiAgentSection(steps, fallback, search = window.location.search) {
  const section = new URLSearchParams(search).get("section");
  return steps.some(step => step.id === section) ? section : fallback;
}

export const AI_AGENT_SUBMENU_ITEMS = [
  {
    key: "ai_agent_settings",
    label: "Setup",
    path: "/app/ai-agent/settings",
    icon: "settings",
    description: "Set up business answers, enquiry collection and team assistance.",
    action: "Open setup",
    permissionCodes: [FK.AI_AGENT_SETTINGS_VIEW],
  },
  {
    key: "ai_agent_lead_qualification",
    label: "Lead collection",
    path: "/app/ai-agent/lead-qualification",
    icon: "qualification",
    description: "Choose customer questions, confirmation and follow-ups.",
    action: "Manage questions",
    permissionCodes: [FK.AI_AUTO_REPLY_MANAGE],
  },
  {
    key: "ai_agent_lead_qualification_debug",
    label: "Advanced diagnostics",
    path: "/app/ai-agent/lead-qualification/debug",
    icon: "debug",
    description: "Advanced support: inspect saved conversation state and recorded evidence.",
    action: "Open diagnostics",
    permissionCodes: [FK.AI_AUTO_REPLY_MANAGE],
  },
  {
    key: "ai_agent_knowledge_base",
    label: "Business knowledge",
    path: "/app/ai-agent/knowledge",
    icon: "knowledge",
    description: "Manage approved business knowledge used by the AI Agent.",
    action: "Manage Knowledge",
    permissionCodes: [FK.AI_KNOWLEDGE_VIEW],
  },
  {
    key: "ai_agent_media_assets",
    label: "Approved media",
    path: "/app/ai-agent/media-assets",
    icon: "media",
    description: "Manage approved images and documents for AI responses.",
    action: "Manage Media",
    permissionCodes: [FK.AI_MEDIA_ASSETS_VIEW],
  },
  {
    key: "ai_agent_test_console",
    label: "Test your assistant",
    path: "/app/ai-agent/test",
    icon: "test",
    description: "Test business answers or preview your saved conversation without sending customer messages.",
    action: "Open testing",
    permissionCodes: [FK.AI_AGENT_ENABLED, FK.AI_TEST_CONSOLE_USE],
    requireAllPermissions: true,
  },
  {
    key: "ai_agent_usage",
    label: "Usage & activity",
    path: "/app/ai-agent/usage",
    icon: "usage",
    description: "Review AI usage, sending records and saved outcomes.",
    action: "View Usage",
    permissionCodes: [FK.AI_AGENT_USAGE_VIEW],
  },
];

// Keep resource permissions separate for contextual links and direct routes.
// The library entry can open either permitted resource without granting access
// to the other one.
export function getAiAgentMenuItems(can, hasAllAccess, currentPath) {
  const menuKeys = [
    "ai_agent_settings",
    "ai_agent_knowledge_base",
    "ai_agent_lead_qualification",
    "ai_agent_test_console",
    "ai_agent_usage",
    "ai_agent_lead_qualification_debug",
  ];
  return menuKeys.map(key => {
    const item = AI_AGENT_SUBMENU_ITEMS.find(resource => resource.key === key);
    if (key === "ai_agent_knowledge_base") {
      const allowed = code => hasAllAccess || (typeof can === "function" && can(code));
      const openMedia = allowed(FK.AI_MEDIA_ASSETS_VIEW)
        && (!allowed(FK.AI_KNOWLEDGE_VIEW) || currentPath === "/app/ai-agent/media-assets");
      return {
        ...item,
        path: openMedia ? "/app/ai-agent/media-assets" : item.path,
        permissionCodes: [FK.AI_KNOWLEDGE_VIEW, FK.AI_MEDIA_ASSETS_VIEW],
        description: "Manage knowledge sources and approved files for your assistant.",
        action: "Manage knowledge",
      };
    }
    return key === "ai_agent_lead_qualification_debug"
      ? { ...item, group: "advanced" }
      : item;
  });
}
